<template>
    <div id="contact" class="contact">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 offset-sm-0 col-10 offset-1">
                    <h2>Contact</h2>
                </div>
            </div>
            <div class="row" v-html="contactText">
                {{contactText}}
            </div>
        </div>
    </div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/wp/v2/pages/35'
    });

    export default {
        name: 'Contact',
        data(){
            return {
                contactText : "",
            };
        },
        mounted(){
            ax.get().then(response => {
                this.contactText = response.data.content.rendered;
            });
        }
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/contact.scss";
</style>